import { Stack, Text } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { McpUsageHistoryTable, McpUsageSummaryView } from "components/McpUsage";
import { Loader } from "components/Loader";
import {
  getMcpUsageHistory,
  getMcpUsageSummary,
} from "./ConnectedMcpApps.requests";

const ConnectedMcpUsage = () => {
  const summary = useQuery({
    queryKey: ["connectedMcpUsageSummary"],
    queryFn: getMcpUsageSummary,
    retry: false,
    useErrorBoundary: false,
  });
  const history = useQuery({
    queryKey: ["connectedMcpUsageHistory"],
    queryFn: getMcpUsageHistory,
    retry: false,
    useErrorBoundary: false,
  });

  if (summary.isLoading || history.isLoading) return <Loader />;
  if (!summary.data) {
    return (
      <Text ml={6} color="gray.500">
        MCP usage could not be loaded. Please try again.
      </Text>
    );
  }

  const months = history.data?.data ?? [];

  return (
    <Stack spacing={4} ml={4} mt={4} maxWidth="1100px">
      <Text fontWeight="bold" fontSize="lg">
        Company MCP credit usage
      </Text>
      <McpUsageSummaryView {...summary.data} />
      <McpUsageHistoryTable months={months} />
    </Stack>
  );
};

export { ConnectedMcpUsage };
